import React from 'react'
import MarkdownWrapper from '../../utils/markdown-wrapper'

const Wysiwyg = ({ content }) => {
    return (
        <div className="container">
            <div className="content-band wysiwyg">
                <MarkdownWrapper content={content.content} />
            </div>
        </div>
    )
}

export default Wysiwyg
